import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import { i18n } from '@/utils/i18n';

// GiftedPerson
export const giftedPersonSchema = Yup.object().shape({
  phone: Yup.string().required(i18n.t('mix.phone_required')),
  firstName: Yup.string().required(i18n.t('giftShows.firstName_required')),
  lastName: Yup.string().required(i18n.t('giftShows.lastName_required'))
});

// GiftShows
const giftShowsSchema = Yup.object().shape({
  gifts: Yup.array()
    .of(giftedPersonSchema)
    .min(1, i18n.t('giftShows.min_gifts'))
    .max(10, i18n.t('giftShows.max_gifts'))
    .required()
});

// Types
export type GiftShowsData = Yup.InferType<typeof giftShowsSchema>;
export type GiftedPersonData = Yup.InferType<typeof giftedPersonSchema>;

// Resolvers
export const giftShowsResolver = yupResolver(giftShowsSchema);
export const giftedPersonResolver = yupResolver(giftedPersonSchema);
